import * as React from 'react';
import PlusGray from './plus-gray.svg';
import PlusWhite from './plus-white.svg';

type PlusColor = 'gray' | 'white';

type Props = {
    className?: string;
    styleName?: string;
    color?: PlusColor;
};

export const Plus = ({ className, color }: Props) => (
    <img className={className} src={color === 'white' ? PlusWhite : PlusGray} />
);
